<template>
  <div class="languagePicker">
    <el-dropdown
      trigger="click"
      @command="setLanguage"
    >
      <span class="languagePicker__link">
        <span v-if="language === 'fr'">Fr</span>
        <span v-if="language === 'en'">En</span>
        <i class="el-icon-caret-bottom el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="fr">
          <div class="languagePicker__item">
            <img src="@/assets/images/flags/fr.svg" />
            <span>Français</span>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="en">
          <div class="languagePicker__item">
            <img src="@/assets/images/flags/en.svg" />
            <span>English</span>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "LanguagePicker",
  computed: {
    language() {
      return this.$store.getters['language']
    }
  },
  methods: {
    setLanguage(language) {
      this.$store.dispatch('setLanguage', language)
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.languagePicker';

#{$c} {
  &__link {
    cursor: pointer;
    border: 1px solid #e7e7e7;
    height: 34px;
    width: 52px;
    border-radius: 6px;
    box-shadow: 0 2px 4px 0 rgba(180, 180, 180, 0.5);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
  }
  &__item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100px;
    padding: 5px;

    span {
      line-height: 32px;
    }
    img {
      width: 32px;
      height: 32px;
    }
  }
}
</style>